/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  createEmployeeId,
  createUserDetails,
  getDropDownList,
  saveUserAsDraft,
  updateBankDetails,
  updateUserDetails,
  uploadFileWithPresignedUrl,
} from "../../store/PeopleSlice/thunk";
import {
  commonFields,
  commonUpdateFields,
  createUserSamplePayload,
} from "../../constants/people";
import ArrowbackIcon from "../../assets/icons/arrow_back.svg";
import SubmitIcon from "../../assets/icons/inventory.svg";
import DownloadIcon from "../../assets/icons/download.svg";
import SuccessIcon from "../../assets/icons/users-check.svg";
import DraftIcon from "../../assets/icons/contract_edit.svg";
import ValidIcon from "../../assets/icons/emergency_home_white.svg";
import CloseIcon from "../../assets/icons/close_white.svg";
import AddEmployeeForm from "../../components/AddEmployeeForm";
import CommonModal from "../../commonComponents/CommonModal";
import { peopleActions } from "../../store/PeopleSlice";
import {
  convertDraftResponseToPayload,
  convertResponseToPayload,
  isEmpty,
  mapValuesFromUserDatatoSamplePayload,
} from "../../utils/people";
import "./AddEmployee.css";
import moment from "moment";

const AddEmployee = () => {
  const navigate = useNavigate();
  const openModalRef = useRef();
  const closeModalRef = useRef();
  const openSuccessModalRef = useRef();
  const closeSuccessModalRef = useRef();
  const dispatch = useDispatch();

  const isEdit = useSelector((state) => state?.people?.isEdit);
  const isDraft = useSelector((state) => state?.people?.isDraft);
  const userDetails = useSelector((state) => state?.people?.userDetails);
  const user_type = useSelector(
    (state) => state.auth?.loginResponse?.body?.role_type,
  );
  const employeeIdStatus = useSelector(
    (state) => state?.people?.employeeIdStatus,
  );
  const employeeId = useSelector((state) => state?.people?.employeeId);
  const createUserStatus = useSelector(
    (state) => state?.people?.createUserStatus,
  );
  const draftDataStatus = useSelector(
    (state) => state?.people?.draftDataStatus,
  );
  const updateUserDetailsStatus = useSelector(
    (state) => state?.people?.updateUserDetailsStatus,
  );
  const updateBankDetailsStatus = useSelector(
    (state) => state?.people?.updateBankDetailsStatus,
  );
  const fileUploadStatus = useSelector(
    (state) => state?.people?.fileUploadStatus,
  );
  const fileUploadResponse = useSelector(
    (state) => state?.people?.fileUploadResponse,
  );

  const [showOptional, setShowOptional] = useState(true);
  const [isError, setIsError] = useState(false);
  const [userData, setUserData] = useState({
    user_details: {
      employee_status: "A",
      nationality: "Indian",
      confirmation_status: "Confirmed",
      education: [
        {
          university_name: null,
          educational_category: null,
          education_degree: null,
          field_of_specualisation: null,
          course_type: null,
          gpa: null,
          start_date: null,
          end_date: null,
        },
      ],
      job_history: [
        {
          company_name: null,
          job_title: null,
          job_location: null,
          job_summary: null,
          start_date: null,
          end_date: null,
          current_check: false,
        },
      ],
      misc: {},
    },
    bank_details: {
      account_type: "Savings",
    },
    doc_details: {},
  });
  const [formCheck, setFormCheck] = useState(false);
  const [previousExp, setPreviousExp] = useState(false);
  const [updatedUserData, setupdatedUserData] = useState({});
  const [validationErrorList, setValidationErrorList] = useState({});
  const [showValidationError, setShowValidationError] = useState(false);
  const [ageValidationError, setAgeValidationError] = useState(false);
  const keysToDeleteOnUpdate = [
    "employee_id",
    "first_name",
    "last_name",
    "middle_name",
    "line_1_address",
    "line_2_address",
    "city",
    "state",
    "address_country",
    "pincode",
    "ad_create_datetime",
    "update_datetime_rds",
    "create_id",
    "create_date",
    "iscreated_ad",
    "modify_id",
    "modify_date",
  ];
  const keysToDeleteSubmit = [
    "first_name",
    "last_name",
    "middle_name",
    "ad_create_datetime",
    "update_datetime_rds",
    "create_id",
    "create_date",
    "iscreated_ad",
    "modify_id",
    "modify_date",
  ];
  const keysToDeleteOnBankSubmit = ["pf_number", "tds_applicability"];

  useEffect(() => {
    dispatch(getDropDownList({}));
    return () => {
      dispatch(peopleActions.resetUserDetailsData());
      dispatch(peopleActions.updateEdit(false));
      dispatch(peopleActions.updateDraft(false));
      dispatch(peopleActions.setInitialState());
    };
  }, []);

  useEffect(() => {
    if (userData?.user_details?.job_history?.length) {
      setPreviousExp(true);
    }
  }, [userData]);

  useEffect(() => {
    if (userData?.user_details) {
      setupdatedUserData({
        data: { ...userData?.user_details },
        bank_data: {
          ...userData?.bank_details,
        },
      });
    }
  }, [userData]);

  useEffect(() => {
    if (
      createUserStatus === "SUCCESS" ||
      draftDataStatus === "SUCCESS" ||
      (updateUserDetailsStatus === "SUCCESS" &&
        updateBankDetailsStatus === "SUCCESS")
    ) {
      navigate("../../people");
    }
    return () => {
      dispatch(peopleActions.resetCreateUserResponse());
      dispatch(peopleActions.resetDratfDataResponse());
      if (
        updateUserDetailsStatus === "SUCCESS" &&
        updateBankDetailsStatus === "SUCCESS"
      ) {
        dispatch(peopleActions.resetUpdateUserDataResponse());
        dispatch(peopleActions.resetUpdateBankDataResponse());
      }
    };
  }, [
    createUserStatus,
    draftDataStatus,
    updateUserDetailsStatus,
    updateBankDetailsStatus,
  ]);

  useEffect(() => {
    if (isEdit || isDraft) {
      setUserData({
        user_details: isDraft
          ? convertDraftResponseToPayload(userDetails, "user_details")
          : convertResponseToPayload(userDetails, "user_details"),
        bank_details: { ...userDetails?.bank_details },
        doc_details: { ...userDetails?.doc_details },
      });
    } else {
      if (!userData?.user_details?.employee_id) {
        dispatch(createEmployeeId({}));
      }
    }
  }, [isEdit, isDraft]);

  useEffect(() => {
    if (employeeIdStatus === "SUCCESS") {
      setUserData({
        user_details: {
          ...userData?.user_details,
          employee_id: String(employeeId?.employee_id),
        },
        bank_details: { ...userData?.bank_details },
        doc_details: { ...userDetails?.doc_details },
      });
    }
    return () => {
      dispatch(peopleActions.resetEmployeeResponse());
    };
  }, [employeeIdStatus]);

  useEffect(() => {
    if (fileUploadStatus === "SUCCESS") {
      setUserData({
        user_details: { ...userData?.user_details },
        bank_details: {
          ...userData?.bank_details,
        },
        doc_details: {
          ...userData?.doc_details,
          [fileUploadResponse?.key]:
            fileUploadResponse?.presignedUrlResponse?.fields?.key,
        },
      });
    }
  }, [fileUploadStatus]);

  // upload file
  const onUploadFile = (keyName, file) => {
    dispatch(
      uploadFileWithPresignedUrl({
        employee_id: userData?.user_details?.employee_id,
        file: file,
        key: keyName,
      }),
    );
  };

  // create new user
  const validatePayload = (payload, fields) => {
    const errors = {};

    const validateObject = (obj, fieldSet) => {
      for (const [key, value] of Object.entries(fieldSet)) {
        if (value.required && !obj[key]) {
          errors[key] = {
            message: `${key} is required`,
            section: value.section,
          };
        } else if (value?.regex && obj[key] && !value.regex.test(obj[key])) {
          errors[key] = {
            message: `${key} is invalid`,
            section: value.section,
          };
        }
      }
    };

    validateObject(payload.user_details, fields?.user_details);
    validateObject(payload.bank_details, fields?.bank_details);
    validateObject(payload.doc_details, fields?.doc_details);

    return errors;
  };

  const onCreateUser = () => {
    try {
      setValidationErrorList({});
      setShowValidationError(false);
      setIsError(false);
      let updatedPayload = mapValuesFromUserDatatoSamplePayload(
        userData,
        createUserSamplePayload,
      );

      const isValidPayload = validatePayload(updatedPayload, commonFields);
      console.log("isValidPayload", isValidPayload);

      if (Object.keys(isValidPayload)?.length) {
        let uniqueErrorSections = [
          ...new Set(
            Object.keys(isValidPayload).map((key) => {
              return isValidPayload[key].section;
            }),
          ),
        ];
        console.log("uniqueErrorSections", uniqueErrorSections);

        setValidationErrorList(uniqueErrorSections);
        setIsError(true);
        setShowValidationError(true);
        return;
      } else {
        let finalPayload = { ...updatedPayload };
        if (finalPayload?.user_details?.date_of_birth) {
          const dateDiff = moment(new Date()).diff(
            moment(finalPayload?.user_details?.date_of_birth),
            "years",
          );
          if (dateDiff < 18) {
            setAgeValidationError(true);
            return;
          }
        }
        keysToDeleteSubmit.forEach((key) => {
          delete finalPayload.user_details[key];
        });
        dispatch(
          createUserDetails({
            ...finalPayload,
            employee_id: updatedPayload?.user_details.employee_id,
          }),
        );
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  // save user as draft
  const onSaveUser = () => {
    try {
      let updatedPayload = mapValuesFromUserDatatoSamplePayload(
        userData,
        createUserSamplePayload,
        "draft",
      );
      dispatch(
        saveUserAsDraft({
          ...updatedPayload,
          employee_id: updatedPayload?.user_details.employee_id,
        }),
      );
    } catch (error) {
      console.log("error", error);
    }
  };

  // update existing user
  const onUpdateUserData = ({ key, value, type = "user" }) => {
    let updatedUserDataPayload = {
      data: { ...updatedUserData.data },
      bank_data: { ...updatedUserData.bank_data },
      employee_id: userData?.user_details?.employee_id,
      user_type: user_type,
    };

    if (type === "user") {
      updatedUserDataPayload = {
        ...updatedUserDataPayload,
        data: { ...updatedUserDataPayload?.data, [key]: value },
      };
    }
    if (type === "bank") {
      updatedUserDataPayload = {
        ...updatedUserDataPayload,
        bank_data: { ...updatedUserDataPayload?.bank_data, [key]: value },
      };
    }
    setupdatedUserData(updatedUserDataPayload);
  };

  const validateUpdatePayload = (payload, fields) => {
    const errors = {};

    const validateObject = (obj, fieldSet) => {
      for (const [key, value] of Object.entries(fieldSet)) {
        if (value.required && !obj[key]) {
          errors[key] = {
            message: `${key} is required`,
            section: value.section,
          };
        } else if (value?.regex && obj[key] && !value.regex.test(obj[key])) {
          errors[key] = {
            message: `${key} is invalid`,
            section: value.section,
          };
        }
      }
    };

    validateObject(payload.data, fields?.user_details);
    validateObject(payload.bank_data, fields?.bank_details);

    return errors;
  };

  const onUpdateEmployee = () => {
    try {
      setValidationErrorList({});
      setShowValidationError(false);
      setAgeValidationError(false);
      setIsError(false);
      let currentPayload = { ...updatedUserData };
      // remove empty fields for edit
      let updatedEditData = { data: {}, bank_data: {} };
      Object.keys(currentPayload?.data).forEach((key) => {
        if (
          (((key === "date_of_exit" || key === "date_of_resignation") &&
            !currentPayload?.data[key]) ||
            currentPayload?.data[key]) &&
          !isEmpty(currentPayload?.data[key])
        ) {
          if (key === "date_of_exit") {
            updatedEditData.data["date_of_exit"] = currentPayload?.data[key]
              ? currentPayload?.data[key]
              : null;
          } else if (key === "date_of_resignation") {
            updatedEditData.data["date_of_resignation"] = currentPayload?.data[
              key
            ]
              ? currentPayload?.data[key]
              : null;
          } else {
            updatedEditData.data[key] =
              currentPayload?.data[key] === "None"
                ? ""
                : currentPayload?.data[key];
          }
        }
      });

      Object.keys(currentPayload?.bank_data).forEach((key) => {
        if (
          currentPayload?.bank_data[key] &&
          !isEmpty(currentPayload?.bank_data[key])
        ) {
          updatedEditData.bank_data[key] =
            currentPayload?.bank_data[key] === "None"
              ? ""
              : currentPayload?.bank_data[key];
        }
      });
      let finalPayload = {
        ...updatedUserData,
        data: updatedEditData.data,
        bank_data: updatedEditData.bank_data,
      };
      console.log("final payload", finalPayload);

      if (finalPayload?.data?.date_of_birth) {
        const dateDiff = moment(new Date()).diff(
          moment(finalPayload?.data?.date_of_birth),
          "years",
        );
        if (dateDiff < 18) {
          setAgeValidationError(true);
          return;
        }
      }

      // payload validation
      const isValidUpdatePayload = validateUpdatePayload(
        finalPayload,
        commonUpdateFields,
      );
      console.log("isValidUpdatePayload", isValidUpdatePayload);

      if (Object.keys(isValidUpdatePayload)?.length) {
        let uniqueErrorSections = [
          ...new Set(
            Object.keys(isValidUpdatePayload).map((key) => {
              return isValidUpdatePayload[key].section;
            }),
          ),
        ];
        console.log("uniqueErrorSections", uniqueErrorSections);

        setValidationErrorList(uniqueErrorSections);
        setIsError(true);
        setShowValidationError(true);
        return;
      } else {
        // delete noneditable fields from list
        keysToDeleteOnUpdate.forEach((key) => {
          delete finalPayload.data[key];
        });
        keysToDeleteOnBankSubmit.forEach((key) => {
          delete finalPayload.bank_data[key];
        });
        dispatch(
          updateUserDetails({
            employee_id: userData?.user_details?.employee_id,
            user_type: user_type,
            data: finalPayload?.data,
          }),
        );
        dispatch(
          updateBankDetails({
            employee_id: userData?.user_details?.employee_id,
            user_type: user_type,
            data: finalPayload?.bank_data,
          }),
        );
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  // Custom Templates
  const CreateFromTemplateModal = () => (
    <div className="flex flex-col">
      <div className="cfr-subtext">
        Upload file with all required fileds completed to create employees
        individually or in bulk.
      </div>
      <div className="cfr-btn flex justify-between">
        <div className="cfr-btn-text">Download template file</div>
        <div className="cfr-ico-wrap">
          <img className="cfr-btn-img" src={DownloadIcon} alt="" />
        </div>
      </div>
      <div className="flex cfr-upload">
        <div className="cfr-upload-text">
          Drag and drop here or browse to upload
        </div>
      </div>
      <button
        className="btn p-btn p-btn-og justify-center"
        onClick={() => openSuccessModalRef.current.click()}
      >
        <div className="p-btn-text">Import Employee</div>
      </button>
    </div>
  );

  const CreateFromTemplateSuccessModal = () => (
    <div className="flex flex-col">
      <div className="flex justify-center">
        <img className="cfts-img" src={SuccessIcon} alt="" />
      </div>
      <div className="cfts-text">
        5/5 Employees Profile Imported Successfully.
      </div>
      <button className="btn p-btn p-btn-og justify-center">
        <div className="p-btn-text">View Details</div>
      </button>
    </div>
  );

  const ValidationErrorPopUp = () => {
    useEffect(() => {
      const timer = setTimeout(() => {
        setShowValidationError(false);
      }, 5000);

      return () => clearTimeout(timer);
    }, []);
    return (
      <div className="flex vl-err">
        <img src={ValidIcon} alt="err-ic" />
        <div className="flex flex-col">
          <div className="vl-err-main">
            Uh oh! It looks like some fields are incomplete
          </div>
          <div className="vl-err-subtext">
            Please navigate to the below sections to complete all details
          </div>
          {validationErrorList &&
            validationErrorList.map((key) => (
              <div className="vl-err-value capitalize" key={key}>
                {key}
              </div>
            ))}
        </div>
        <div className="vl-close">
          <img
            className="vl-close-ico"
            src={CloseIcon}
            alt="close-ico"
            onClick={() => setShowValidationError(false)}
          />
        </div>
      </div>
    );
  };
  const DOBPopUp = () => {
    useEffect(() => {
      const timer = setTimeout(() => {
        setAgeValidationError(false);
      }, 5000);

      return () => clearTimeout(timer);
    }, []);
    return (
      <div className="flex vl-err">
        <img src={ValidIcon} alt="err-ic" />
        <div className="flex flex-col">
          <div className="vl-err-main">
            Uh oh! It looks like some issue while submit
          </div>
          <div className="vl-err-value capitalize">
            Employee age should be greater than 18 years !
          </div>
        </div>
        <div className="vl-close">
          <img
            className="vl-close-ico"
            src={CloseIcon}
            alt="close-ico"
            onClick={() => setAgeValidationError(false)}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col add-emp">
      <div className="flex justify-between">
        <div
          className="flex items-center"
          onClick={() => {
            dispatch(peopleActions.updateEdit(false));
            dispatch(peopleActions.updateDraft(false));
            navigate("../../people");
          }}
        >
          <img className="arrow-icon" src={ArrowbackIcon} alt="arrow-back" />
          <div className="emp-head">
            {isEdit || isDraft ? "update" : "new"} employee
          </div>
        </div>
        <div className="flex items-center">
          <div className="opt-field mr-2">
            <div className="form-check form-switch flex items-center">
              <input
                className="form-check-input mb-1"
                type="checkbox"
                role="switch"
                id="flexSwitchCheckDefault"
                onChange={(e) => setShowOptional(e.target.checked)}
                checked={showOptional}
              />
              <label
                className="form-check-label"
                htmlFor="flexSwitchCheckDefault"
              >
                Show Optional Fields & Categories
              </label>
            </div>
          </div>
          <div className="flex w-full">
            {!isEdit && (
              <div className="btn p-btn p-btn-blk" onClick={onSaveUser}>
                <img className="p-btn-icon" src={DraftIcon} alt="" />
                <div className="p-btn-text">Save as Draft</div>
              </div>
            )}
            <button
              className="btn p-btn p-btn-og position-relative"
              onClick={() => {
                if (isEdit) {
                  onUpdateEmployee();
                } else {
                  onCreateUser();
                }
              }}
              disabled={!formCheck}
            >
              <img className="p-btn-icon" src={SubmitIcon} alt="" />
              <div className="p-btn-text">Submit</div>
            </button>
            {showValidationError && <ValidationErrorPopUp />}
            {ageValidationError && <DOBPopUp />}
          </div>
        </div>
      </div>
      <AddEmployeeForm
        isEdit={isEdit}
        isDraft={isDraft}
        showOptional={showOptional}
        isError={isError}
        setUserData={setUserData}
        userData={userData}
        onUploadFile={onUploadFile}
        setUpdateData={onUpdateUserData}
        setFormCheck={setFormCheck}
        formCheck={formCheck}
        previousExp={previousExp}
        setPreviousExp={setPreviousExp}
      />
      <CommonModal
        openRef={openModalRef}
        closeRef={closeModalRef}
        id={"CreateFromTemplateModal"}
        modalHeadText={"create from template"}
        hideCloseButton={false}
        content={<CreateFromTemplateModal />}
        disabled={false}
        size={"md"}
      />
      <CommonModal
        openRef={openSuccessModalRef}
        closeRef={closeSuccessModalRef}
        id={"CreateFromTemplateSuccessModal"}
        modalHeadText={"create from template"}
        hideCloseButton={false}
        content={<CreateFromTemplateSuccessModal />}
        disabled={false}
        size={"md"}
      />
    </div>
  );
};
export default AddEmployee;
